import type { KycStatus } from '@entities/session';
import type { ManufacturerProfile } from '../model/types';

export interface KycSubmitGate {
  canSubmit: boolean;
  missing: string[];
}

export function getKycSubmitGate(profile: ManufacturerProfile): KycSubmitGate {
  const missing: string[] = [];
  if (!profile.companyName?.trim()) missing.push('companyName');
  if (!profile.country) missing.push('country');
  if (profile.categories.length === 0) missing.push('categories');
  if (profile.certificates.length === 0) missing.push('certificates');
  if (profile.ecoProducer && profile.ecoCertificates.length === 0) {
    missing.push('ecoCertificates');
  }
  return { canSubmit: missing.length === 0, missing };
}

export function isKycActionable(status: KycStatus): boolean {
  return status === 'NONE' || status === 'REJECTED';
}

export function isVendorVerified(status: KycStatus | undefined): boolean {
  return status === 'VERIFIED';
}
